<app-work-group-activity
    class="pt-2 subpage-content"
    [personIdInput]="folderStore.folder()?.personId || null"
    (closeCallback)="dialogRef.close()"
></app-work-group-activity>

<div #dialogFooter></div>
